import React from "react";
import Sidebar from "../Navegacion/Sidebar";
import Topbar from "../Navegacion/Topbar";
import Footer from "../Footer/Footer";
import { CerrarNotificador } from "../Notificador";

class Layout extends React.Component {
  render() {
    CerrarNotificador();
    return (
      <>
        <div id="wrapper">
          {/* <!-- Sidebar --> */}
          <Sidebar />
          {/* <!-- End of Sidebar --> */}

          {/* <!-- Content Wrapper --> */}
          <div id="content-wrapper" className="d-flex flex-column">
            {/* <!-- Main Content --> */}
            <div id="content">
              {/* <!-- Topbar --> */}
              <Topbar />
              {/* <!-- End of Topbar --> */}

              {/* <!-- Begin Page Content --> */}
              <div className="container-fluid">
                <main>{this.props.children}</main>
              </div>
              {/* <!-- /.container-fluid --> */}
            </div>
            {/* <!-- End of Main Content --> */}

            {/* <!--Componete de  Footer --> */}
            <Footer />
            {/* <!-- End of Footer --> */}
          </div>
          {/* <!-- End of Content Wrapper --> */}
        </div>
        {/* <!-- End of Page Wrapper --> */}

        {/* <!-- Scroll to Top Button--> */}
        <a className="scroll-to-top rounded" href="#page-top">
          <i className="fas fa-angle-up"></i>
        </a>
      </>
    );
  }
}

export default Layout;
